import { BaseFilter } from './BaseFilter';
import { Param } from '../Param';

export class ValueFilter extends BaseFilter {
    constructor({ id, value }) {
        super();
        this.id = id;
        this._value = value;
    }

	getValue() {
		return this._value;
	}

    setValue(value) {
        this._value = value;
    }


    toParam() {
        return new Param({ id: this.id, value: this.getValue() });
    }
}
